export default class RGBA {
	r: number;
	g: number;
	b: number;
	a: number;

	constructor (r: number, g: number, b: number, a: number) {
		this.r = r;
		this.g = g;
		this.b = b;
		this.a = a;
	}

	setRGB (r: number, g: number, b: number) {
		this.r = r / 255;
		this.g = g / 255;
		this.b = b / 255;
	}

	setHex (hex: number) {
		this.r = (hex >> 24 & 255) / 255;
		this.g = (hex >> 16 & 255) / 255;
		this.b = (hex >> 8  & 255) / 255;
		this.a = (hex       & 255) / 255;
	}

	toString () {
		return 'rgba(' + Math.round(255 * this.r) + ', ' + Math.round(255 * this.g) + ', ' + Math.round(255 * this.b) + ', ' + this.a + ')';
	}
}
